<div [ngClass]="class">
  <ng-content></ng-content>
</div>
